var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-38",
    "data-name": "50_Kids_Icons-38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#9ec853"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4746",
    "data-name": "Group 4746",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M187.747,139.2a51.313,51.313,0,0,0,1.9-14.122c0-16.057-6.752-29.075-15.081-29.075s-15.08,13.018-15.08,29.075a51.3,51.3,0,0,0,1.9,14.122Z",
    transform: "translate(-134.565 -81)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    "data-name": "Group 4747",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M128.4,378.374l-.008-.132c0-8-3-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.131Z",
    transform: "translate(-59.398 -298.374)",
    fill: "#a34322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M128.39,391.182c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.131h58Z",
    transform: "translate(-59.398 -311.313)",
    fill: "#eb7fa8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750",
    transform: "translate(14.917 14.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M100.091,138.394a46.722,46.722,0,0,1-1.07-24.308c1.407-6.331,4.253-12.586,9-17.105A16.81,16.81,0,0,1,119.4,92.073a1.219,1.219,0,0,0,0-2.437c-13.46.07-21.116,14.418-23.163,25.991a49.05,49.05,0,0,0,1.508,23.414c.479,1.489,2.832.852,2.349-.647Z",
    transform: "translate(-95.471 -89.636)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(3.833 0.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M125.645,139.478a46.2,46.2,0,0,1-1.037-24.176c1.447-6.406,4.325-12.577,9.119-16.99.258-.238.525-.468.794-.695.4-.331.446-.364.74-.579a20.2,20.2,0,0,1,1.846-1.2c.289-.167.585-.321.881-.472.147-.075.3-.146.447-.218.054-.026.65-.288.335-.156a16.581,16.581,0,0,1,2.008-.683,1.742,1.742,0,0,0-.926-3.356c-6.031,1.665-10.705,6.252-13.884,11.484a44.442,44.442,0,0,0-5.931,21.379,48.639,48.639,0,0,0,2.251,16.588,1.741,1.741,0,0,0,3.357-.926Z",
    transform: "translate(-120.004 -90.882)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753",
    transform: "translate(39.251 14.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751",
    transform: "translate(0.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M278.738,139.042A49.317,49.317,0,0,0,280,114.307a37.083,37.083,0,0,0-8.817-18.047,19.749,19.749,0,0,0-14.1-6.623,1.219,1.219,0,0,0,0,2.438c5.607.029,10.372,3.3,13.8,7.553,4.254,5.271,6.517,12.151,7.332,18.8a46.8,46.8,0,0,1-1.828,19.965c-.483,1.5,1.871,2.136,2.349.647Z",
    transform: "translate(-255.904 -89.637)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752",
    transform: "translate(0 0.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M270.928,140.4a49.864,49.864,0,0,0,1.229-25.148,37.273,37.273,0,0,0-9.179-18.408,21.514,21.514,0,0,0-9.612-5.895,1.742,1.742,0,0,0-.925,3.356,17.548,17.548,0,0,1,6.786,3.766,25.93,25.93,0,0,1,5.612,7.149,42.281,42.281,0,0,1,4.881,21.113,44.843,44.843,0,0,1-2.147,13.141,1.74,1.74,0,0,0,3.355.926Z",
    transform: "translate(-251.209 -90.881)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(21.758 35.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M146.4,229.854c1.09,2.592.5,5.113-1.328,5.628s-4.183-1.168-5.273-3.76-.5-5.112,1.324-5.629S145.305,227.26,146.4,229.854Z",
    transform: "translate(-139.248 -226)",
    fill: "#a34322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M324.073,229.854c-1.09,2.592-.5,5.113,1.326,5.628s4.184-1.168,5.273-3.76.5-5.112-1.326-5.629S325.162,227.26,324.073,229.854Z",
    transform: "translate(-294.733 -226)",
    fill: "#a34322"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M226.517,242.674a5.7,5.7,0,0,1-5.7,5.7h-.69a5.7,5.7,0,0,1-5.7-5.7V228a5.7,5.7,0,0,1,5.7-5.7h.689a5.7,5.7,0,0,1,5.7,5.7v14.675Z",
    transform: "translate(-180.925 -187.565)",
    fill: "#a34322"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756",
    transform: "translate(25.562 15.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M191.932,122.687a14.166,14.166,0,0,1-14.166,14.166h0A14.166,14.166,0,0,1,163.6,122.687v-7.332a14.166,14.166,0,0,1,14.166-14.166h0a14.166,14.166,0,0,1,14.166,14.166Z",
    transform: "translate(-163.6 -101.189)",
    fill: "#c67c47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759",
    transform: "translate(32.943 36.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(10.641 0.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M278.939,237.41a1.707,1.707,0,1,1,1.7,1.558A1.637,1.637,0,0,1,278.939,237.41Z",
    transform: "translate(-278.939 -235.851)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M210.837,237.239a1.642,1.642,0,1,1,1.639,1.59A1.615,1.615,0,0,1,210.837,237.239Z",
    transform: "translate(-210.837 -235.65)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M244.2,261.657a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.2,261.657Z",
    transform: "translate(-202.02 -220.773)",
    fill: "#a34322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4761",
    "data-name": "Group 4761",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M171.161,86c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l.729-6.183a7.99,7.99,0,0,1,7.935-7.055h9.83a7.991,7.991,0,0,1,7.936,7.053l.731,6.185a18.051,18.051,0,0,0,2.13-8.566C186.872,93.624,179.838,86,171.161,86Z",
    transform: "translate(-131.161 -72.563)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762",
    transform: "translate(31.426 32.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M201.974,211.8a4.644,4.644,0,0,1,3.443-1.435.5.5,0,0,0,0-1.005,5.654,5.654,0,0,0-4.154,1.729c-.435.479.274,1.192.711.711Z",
    transform: "translate(-201.127 -209.36)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763",
    transform: "translate(43.798 32.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M284.948,211.09a5.653,5.653,0,0,0-4.154-1.729.5.5,0,0,0,0,1.005,4.643,4.643,0,0,1,3.443,1.435c.437.481,1.146-.233.711-.711Z",
    transform: "translate(-280.309 -209.36)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(34.513 44.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M230.622,282.453c-1.751,2.825-6.743,2.833-8.5.016-.448-.714-1.58-.056-1.13.664,2.288,3.661,8.491,3.65,10.768-.02.446-.72-.689-1.374-1.133-.66Z",
    transform: "translate(-220.884 -282.144)",
    fill: "#a91935"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar17);
export default __webpack_public_path__ + "static/media/avatar17.d4fcca924785de924648fb7428a2ae86.svg";
export { ForwardRef as ReactComponent };